import React from 'react';
import { withRouter } from 'react-router-dom';
import { withApollo, compose } from 'react-apollo';

import { DestroyDocument } from '../../mutations/DestroyDocument';
import mapConnection from './../../utils/connectionMapper';
import View from './View';

class PassengerView extends React.Component {
  state = { isConfirmationOpen: false };

  handleDeleteClick = (id, e) => {
    e.stopPropagation();
    this.setState({ documentToDelete: id, isConfirmationOpen: true });
  };

  handleConfirmation = test => {
    if (test) {
      const { client, onClaimUpdated } = this.props;
      const { documentToDelete } = this.state;
      this.setState({ loading: true });
      client
        .mutate({
          mutation: DestroyDocument,
          variables: {
            input: {
              id: documentToDelete
            }
          }
        })
        .then(() => {
          onClaimUpdated();
          this.setState({ loading: false });
        })
        .catch(() => this.setState({ loading: false }));
    }
    this.setState({ isConfirmationOpen: false });
  };

  handleEmailClick = () => {
    const { passenger, history, match } = this.props;
    const { passengerEmail } = passenger || '';
    history.push({
      pathname: `/claim/${match.params.id}/contact/pax`,
      state: { passengerEmail }
    });
  };

  createMarkup = (iban, bicSwift, paxPaypalId, paxTransferChannel) => {
    if (paxTransferChannel === 'Bank transfer') {
      return {
        __html: `Transfer channel: ${paxTransferChannel}</br>
      BIC/SWIFT: ${bicSwift}</br>
      IBAN: ${iban}`
      };
    }
    return {
      __html: `Transfer channel: ${paxTransferChannel}<br>
      PayPal ID: ${paxPaypalId}`
    };
  };

  handleContactPersonChange = () => {
    const { previewOnly, passenger, onContactPersonChange } = this.props;
    return !previewOnly ? onContactPersonChange(passenger) : null;
  };

  render = () => {
    const { passenger } = this.props;
    if (!passenger) return null;
    const claims = passenger.claimsConnection
      ? mapConnection(passenger.claimsConnection)
      : [];

    return (
      <View
        {...this.state}
        {...this.props}
        claims={claims}
        onConfirmation={this.handleConfirmation}
        onDeleteClick={this.handleDeleteClick}
        onEmailClick={this.handleEmailClick}
        createMarkup={this.createMarkup}
        onContactPersonChange={this.handleContactPersonChange}
      />
    );
  };
}

export default compose(withRouter, withApollo)(PassengerView);



// WEBPACK FOOTER //
// ./src/component/PassengerView/index.js